module.exports = __webpack_public_path__ + "img/play.3738acea.png";